var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "StockExpiryreport "
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.listMerchantData1,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.item
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchantname),
      callback: function($$v) {
        _vm.merchantname = $$v
      },
      expression: "merchantname"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('warehouseRacks.stockTypeField')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stocktype),
      expression: "stocktype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "stocktype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.stocktype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('warehouseRacks.stockType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accept"
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject"
    }
  }, [_vm._v("Reject")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "notinpo"
    }
  }, [_vm._v("Not in Po")])])]), _vm._v(" "), (_vm.stocktype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.stocktypeErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('warehouseRacks.subinventory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subinventory),
      expression: "subinventory"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "client"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subinventory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.selectSubInventory')))]), _vm._v(" "), _vm._l((_vm.listsubinventoryData), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.inventoryname
      }
    }, [_vm._v(_vm._s(client_obj.inventoryname))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productIDPlaceholder')
    },
    model: {
      value: (_vm.ProductID),
      callback: function($$v) {
        _vm.ProductID = $$v
      },
      expression: "ProductID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('reports.thresholddays')))]), _vm._v(" "), _c('b-input-group', [_vm._v("\n                          " + _vm._s(this.thresholday) + "\n                      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('reports.expiryFromDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('reports.expiryToDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getStockExpiryReportDataSearch(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('reports.stockExpiryReportList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1.5 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalrows))])]), _vm._v(" "), (_vm.download && _vm.listStockReportData.length > 0) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-320px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.show && _vm.listStockReportData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-206px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getStockReportData(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listStockReportData.length) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-162px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download Excel"
    },
    on: {
      "click": function($event) {
        _vm.getStockReportxslData(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listStockReportData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-162px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listStockReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.clientProductId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('removeHold.brand')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')))]), _vm._v(" "), (_vm.activemrpflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.activemrp')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDate')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('reports.availableShelfLife')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('reports.sumoftotalCSqty')) + ".")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('warehouseRacks.subinventory')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.merchantName')))])])]), _vm._v(" "), _c('tbody', [(_vm.client == '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientNoWarehouseMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.client == '' && _vm.warehouse != '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noSearchBtnMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "14",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listStockReportData), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.brand))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), (_vm.activemrpflag) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.activemrp))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.expirydate || _vm.moment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      class: _vm.getClass(("" + (data.days)), ("" + _vm.thresholday))
    }, [_vm._v(_vm._s(data.days))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.subinventory))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.merchantname))])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listStockReportData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalrows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62382921", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62382921","hasScoped":true}!./src/views/components/reports/brandwisestockexpiryreport/brandwisestockexpiryreport.component.html
// module id = 2003
// module chunks = 0